import { getScheduler } from '@byted/light-render/lib/multi-thread/scheduler';
import { registerFeature } from '@byted/light-render/lib/utils/featureManager';
export var PaintInWorker = {
    install: function () {
        registerFeature('worker', getScheduler);
    },
};
